import { ReactNode } from 'react';
import { useReduxState } from 'hooks';
import { PageInnerContent, PageSidebar } from 'components/page';
import { UserPage } from 'components/user';
import { ProfilePage } from '.';

interface Props {
  activeLink: string;
  children?: ReactNode;
  isUserPage?: boolean;
}

const ProfileLogsPage = ({ activeLink = '', children, isUserPage }: Props) => {
  const {
    messages,
    pageState: { user },
    user: loggedInUser
  } = useReduxState();

  const basePath = isUserPage ? `/users/${user?.id}` : '/profile';

  const sidebarLinks = user
    ? [
        {
          href: `${basePath}/events`,
          icon: 'list' as const,
          title: messages.commonActivityLog
        },
        ...(loggedInUser?.roles.includes('vuoadmin')
          ? [
              {
                href: `${basePath}/changelog`,
                icon: 'user' as const,
                title: 'Change log'
              }
            ]
          : []),
        {
          href: `${basePath}/emails`,
          icon: 'envelope' as const,
          title: messages.emailLog
        },

        {
          href: `${basePath}/logins`,
          icon: 'key' as const,
          title: messages.profileLoginHistory
        }
      ]
    : null;

  if (isUserPage) {
    return (
      <UserPage activeLink="/events" withSidebar={true}>
        <PageSidebar active={`${basePath}${activeLink}`} links={sidebarLinks} />
        <PageInnerContent>{children}</PageInnerContent>
      </UserPage>
    );
  }

  return (
    <ProfilePage activeLink="/events" withSidebar={true}>
      <PageSidebar active={`${basePath}${activeLink}`} links={sidebarLinks} />
      <PageInnerContent>{children}</PageInnerContent>
    </ProfilePage>
  );
};

export default ProfileLogsPage;
